
// export const API_BASE_URL = "https://gm2rx81j-8004.inc1.devtunnels.ms/api/v1/admin"; // replace if needed

//export const API_BASE_URL = "https://newsapp.aasmo.in/api/v1/admin"; // replace if needed
//export const API_BASE_URL = "http://localhost:8004/api/v1/admin";
export const API_BASE_URL = " https://backend.xpressnews.in/api/v1/admin";

//export const API_BASE_URL = "https://backend.emsindia.com/api/v1/admin";


export const API_ADMIN_ENDPOINT = {
 


GET_MY_PROFILE: `${API_BASE_URL}/profile`,
UPDATE_STAFF_CREDENTIALS: `${API_BASE_URL}/admin/update-user-direct`,

  GET_DASHBOARD_STATS: `${API_BASE_URL}/dashboard-stats`, 
  ADD_REPORTER: `${API_BASE_URL}/registerreporter`, // backend route for reporter creation
   ADD_HEADLINE: `${API_BASE_URL}/headline`,
  GET_ALL_HEADLINES: `${API_BASE_URL}/headline`,
  GET_HEADLINE_BY_ID: (headlineId) => `${API_BASE_URL}/headline/${headlineId}`,
  UPDATE_HEADLINE: (headlineId) => `${API_BASE_URL}/headline/${headlineId}`,
  DELETE_HEADLINE: (id) => `${API_BASE_URL}/headline/${id}`, 


   GET_ALL_REPORTERS: `${API_BASE_URL}/reporters`, 
   DELETE_REPORTER: `${API_BASE_URL}/reporters` ,
  UPDATE_REPORTER: `${API_BASE_URL}/reporters`,
RESET_REPORTER_PASSWORD: `${API_BASE_URL}/reporters`,

   CREATE_SHORT:`${API_BASE_URL}/shorts`,
    GET_MY_SHORTS: `${API_BASE_URL}/shorts`,
  DELETE_SHORT: `${API_BASE_URL}/shorts` , 
  UPDATE_SHORT: `${API_BASE_URL}/shorts`,

  GET_ALL_SHORTS_ADMIN: `${API_BASE_URL}/shorts/admin/list`,
UPDATE_SHORT_STATUS_ADMIN: `${API_BASE_URL}/shorts/admin`,
UPDATE_SHORT_ADMIN: `${API_BASE_URL}/shorts`,
DELETE_SHORT_ADMIN: `${API_BASE_URL}/shorts`,
    // --- NEWS ENDPOINTS (New) ---
  GET_ALL_NEWS: `${API_BASE_URL}/news`,
BULK_DELETE_NEWS: `${API_BASE_URL}/news-bulk-delete`,
BULK_NEWS_PREVIEW:`${API_BASE_URL}/news-bulk-preview`,
  GET_NEWS_BY_ID: (newsId) => `${API_BASE_URL}/news/${newsId}`,
  UPDATE_NEWS: (newsId) => `${API_BASE_URL}/news/${newsId}`,
  DELETE_NEWS: (newsId) => `${API_BASE_URL}/news/${newsId}`,
  LIKE_NEWS: (newsId) => `${API_BASE_URL}/news/${newsId}/like`,
  COMMENT_NEWS: (newsId) => `${API_BASE_URL}/news/${newsId}/comment`,
  CREATE_POLL:`${API_BASE_URL}/polls`,
  GET_ALL_POLLS:`${API_BASE_URL}/polls`,
  GET_POLL_RESULTS:`${API_BASE_URL}/polls`,
  UPDATE_POLL:`${API_BASE_URL}/polls`,
  DELETE_POLL:`${API_BASE_URL}/polls`,

  CREATE_VIDEO: `${API_BASE_URL}/video`,
  GET_ALL_VIDEOS: `${API_BASE_URL}/video`,
  UPDATE_VIDEO: `${API_BASE_URL}/video`,
  DELETE_VIDEO: `${API_BASE_URL}/video`,
  GET_ALL_VIDEOS_ADMIN: `${API_BASE_URL}/video/admin/list`,
UPDATE_VIDEO_ADMIN: `${API_BASE_URL}/video/admin`,
DELETE_VIDEO_ADMIN: `${API_BASE_URL}/video/admin`,


   CREATE_TAG: `${API_BASE_URL}/createTag`,
  GET_ALL_TAGS: `${API_BASE_URL}/getAllTags`,
  UPDATE_TAG: `${API_BASE_URL}/updateTag`,
  DELETE_TAG: `${API_BASE_URL}/deleteTag`,
  GET_TRENDING_TAGS: `${API_BASE_URL}/getTrendingTopics`,

    GET_ALL_CATEGORIES:`${API_BASE_URL}/categories`,
   CREATE_CATEGORY :`${API_BASE_URL}/categories`,
 UPDATE_CATEGORY :`${API_BASE_URL}/categories`,
 DELETE_CATEGORY:`${API_BASE_URL}/categories`,

   // SubCategory
  CREATE_SUBCATEGORY: `${API_BASE_URL}/subcategories`,
  GET_ALL_SUBCATEGORIES: `${API_BASE_URL}/subcategories`,
  GET_SUBCATEGORY_BY_ID: `${API_BASE_URL}/subcategories`, // + /:id
  GET_SUBCATEGORY_BY_CATEGORY: `${API_BASE_URL}/subcategories/category`, // + /:categoryId
  UPDATE_SUBCATEGORY: `${API_BASE_URL}/subcategories`, // + /:id
  DELETE_SUBCATEGORY: `${API_BASE_URL}/subcategories`, // + /:id


  SET_CATEGORY_NEWS:`${API_BASE_URL}/set-category`, 
    GET_CATEGORY_NEWS:`${API_BASE_URL}/selected-categories`,
  CREATE_NEWS: `${API_BASE_URL}/news`,


  GET_MY_NEWS: `${API_BASE_URL}/getNewsByReporter`,
  GET_ALL_ADMIN_NEWS: `${API_BASE_URL}/get-all-news`,
  UPDATE_NEWS_STATUS: (id) => `${API_BASE_URL}/news-status/${id}`,

  CREATE_STORY:`${API_BASE_URL}/createStory`,
  DELETE_STORY:`${API_BASE_URL}/createStory`,
  GET_ALL_STORIES:`${API_BASE_URL}/Stories`,
  GET_STORY_BY_ID:`${API_BASE_URL}/getStoryById`,
  ADD_SLIDES:`${API_BASE_URL}/createStory/slides`,
GET_ALL_STORIES_ADMIN: `${API_BASE_URL}/allStories`,  
 UPDATE_STORY_STATUS: `${API_BASE_URL}/admin/`,  





  UPLOAD_MEDIA:`${API_BASE_URL}/upload-media`,
  
  
  GET_ALL_ADS: `${API_BASE_URL}/ads`,
    CREATE_AD: `${API_BASE_URL}/ads`,
    UPDATE_AD: (id) => `${API_BASE_URL}/ads/${id}`,
    DELETE_AD: (id) => `${API_BASE_URL}/ads/${id}`,
  
  
     GET_ALL_CompanyCATEGORIES: `${API_BASE_URL}/createCompanyCategory`,
  CREATE_CompanyCATEGORY: `${API_BASE_URL}/createCompanyCategory`,
  UPDATE_CompanyCATEGORY: `${API_BASE_URL}/createCompanyCategory`,
  DELETE_CompanyCATEGORY: `${API_BASE_URL}/createCompanyCategory`,


  DELETE_CompanySUBCATEGORY:`${API_BASE_URL}/createCompanySubCategory`,
  UPDATE_CompanySUBCATEGORY:`${API_BASE_URL}/createCompanySubCategory`,
  CREATE_CompanySUBCATEGORY:`${API_BASE_URL}/createCompanySubCategory`,
  GET_ALL_CompanySUBCATEGORIES:`${API_BASE_URL}/createCompanySubCategory`,

 GET_COMPANIES_BY_CATEGORY: `${API_BASE_URL}/getCompaniesByCategory`,
   UPDATE_COMPANY_DETAILS: `${API_BASE_URL}/companies`,
  GET_ALL_COMPANIES: `${API_BASE_URL}/getAllCompanies`,
  APPROVE_COMPANY: `${API_BASE_URL}/approve`,
  REJECT_COMPANY: `${API_BASE_URL}/reject`,

   GET_PENDING_UPDATES: `${API_BASE_URL}/pending-updates`,
  APPROVE_COMPANY_UPDATE: `${API_BASE_URL}/getApprovedCompanies`,
  REJECT_COMPANY_UPDATE: `${API_BASE_URL}/reject`, 

  GET_ALL_PRODUCTS_ADMIN: `${API_BASE_URL}/admin/products`,
  APPROVE_PRODUCT_ADMIN: `${API_BASE_URL}/products/approve`, // Note: Backend route is /products/approve/:productId
  REJECT_PRODUCT_ADMIN: `${API_BASE_URL}/products/reject`,   // Note: Backend route is /admin/products/reject/:productId
  ADMIN_DELETE_PRODUCT: `${API_BASE_URL}/products`,           // NEW: Assuming 
  DOWNLOAD_NEWS_PDF:`${API_BASE_URL}/download-pdf`,   

  CREATE_LIVE_NEWS: `${API_BASE_URL}/createLiveNews`, 
   ADD_LIVE_UPDATE: `${API_BASE_URL}/addLiveUpdate`, 
   GET_ALL_LIVE_NEWS: `${API_BASE_URL}/live-news`,

  GET_LIVE_NEWS_BY_ID: `${API_BASE_URL}/getLiveNews`,


  END_LIVE_NEWS: `${API_BASE_URL}/endLiveNews`,


};
